// ** Custom Menu Components
import VerticalNavLink from './VerticalNavLink'
import VerticalNavGroup from './VerticalNavGroup'
import VerticalNavSectionTitle from './VerticalNavSectionTitle'

// ** Logic Imports
import { usePermissions } from 'components/context/permissionsContext';

const resolveNavItemComponent = item => {
  if (item.sectionTitle) return VerticalNavSectionTitle
  if (item.children) return VerticalNavGroup

  return VerticalNavLink
}

const VerticalNavItems = props => {
  // ** Props
  const { verticalNavItems } = props
  const { filteredItems } = usePermissions();

  const filterItems = (items, filteredItems) => {
    const hasAllServices = ['Services', 'Inventory', 'Settings'].every(module => 
      filteredItems?.some(filteredItem => filteredItem.module === module)
    );
    
    const hasAllServiceRequests = ['ServiceRequest', 'DispatchBoard', 'Invoice', 'Payment'].every(module => 
      filteredItems?.some(filteredItem => filteredItem.module === module)
    );
  
    return items.filter(item => {
      if (item.sectionTitle) {
        if (item.sectionTitle === 'SecondDivider' && !hasAllServices) {
          return false;
        }
        if (item.sectionTitle === 'FirstDivider' && !hasAllServiceRequests) {
          return false;
        }
        return true;
      }
      
      if (!item.value) return true;
      
      const hasPermission = filteredItems?.some(
        filteredItem => filteredItem.module === item.value
      );
      
      if (item.children) {
        item.children = filterItems(item.children, filteredItems);
        return item.children.length > 0;
      }
      
      return hasPermission;
    });
  };

  const authorizedItems = filterItems(verticalNavItems, filteredItems || [])

  const RenderMenuItems = authorizedItems?.map((item, index) => {
    const TagName = resolveNavItemComponent(item)

    return <TagName {...props} key={index} item={item} />
  })

  return <>{RenderMenuItems}</>
}

export default VerticalNavItems
